<template>
    <div class="error-toast">
        <div class="error-toast__body">
            <span class="error-toast__title">{{
                severity === 'warning' ? t('generic.warning') : t('generic.error')
            }}</span>
            <p class="error-toast__message">{{ message }}</p>
            <button
                v-if="errorId"
                type="button"
                :class="['error-toast__id-pill', { 'error-toast__id-pill--copied': copied }]"
                :title="copied ? t('errorToast.copied') : t('errorToast.copyId')"
                @click="onCopy"
            >
                {{ copied ? `✓ ${t('errorToast.copied')}` : `ID: ${errorId}` }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import { toast } from 'vue3-toastify';
    import { i18n } from '@/utilities/i18n';

    interface Props {
        message: string;
        errorId?: string;
        severity?: 'error' | 'warning';
    }

    const props = defineProps<Props>();
    const t = i18n.global.t;
    const copied = ref(false);

    const copyToClipboard = async (text: string): Promise<void> => {
        try {
            await navigator.clipboard.writeText(text);
        } catch {
            const el = document.createElement('textarea');
            el.value = text;
            el.style.position = 'fixed';
            el.style.opacity = '0';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
    };

    const onCopy = async () => {
        if (!props.errorId) return;
        await copyToClipboard(`id : ${props.errorId}`);
        copied.value = true;
        toast.success(t('errorToast.copySuccess'), { autoClose: 2000 });
        setTimeout(() => {
            copied.value = false;
        }, 2000);
    };
</script>
